import { render } from "./manage-dependents.vue?vue&type=template&id=aefb9584&scoped=true"
import script from "./manage-dependents.vue?vue&type=script&lang=js"
export * from "./manage-dependents.vue?vue&type=script&lang=js"

import "./manage-dependents.vue?vue&type=style&index=0&id=aefb9584&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefb9584"]])

export default __exports__